<script>
export default {
	props: {
		title: {
			type: String
		},
		description: {
			type: String
		},
		module: {
			type: String
		}
	}
}
</script>
<template>
	<div class="wrapper">
		<div class="indications">
			<h2 class="title"><span>{{module}}:</span> {{title}}</h2>
			<div class="description" v-html="description"></div>
			<div><button class="btn btn-bbva" @click="$emit('start')">Iniciar</button></div>
		</div>
		<img class="indications__img" src="@/assets/img/evaluations/indications.png" alt="">
	</div>
</template>
<style lang="scss" scoped>
.wrapper{
	background-image: url('../../assets/img/evaluations/bg_01.png');
	background-attachment: fixed;
	background-size: cover;
	position: relative;
	.indications{
		max-width: 70%;
		padding: 3rem;
		color: #fff;
		&__img{
			width: 70%;
			// position: absolute;
			bottom: 30px;
			display: block;
			margin-left: auto;
			margin-top: -15%;
			// right: 0;
		}
	}
	.title{
		font-size: 3em;
		font-weight: 700;
		span{
			font-weight: 300;
		}
	}
	.description{
		font-size: 1.5em;
	}
}
</style>